import type { ModelData } from '../../types'

export const dragonVisAVis: Record<string, ModelData> = {
  'dragon-2-duo': {
    id: 'dragon-2-duo',
    name: 'DRAGON 2 DUO',
    power: '13 kW',
    type: 'powietrzny nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/dragon-2-duo.jpg',
    emailSubject: 'Zapytanie - DRAGON 2 DUO',
    description: 'Wkład powietrzny dwustronny vis-a-vis 12 kW',
    specialNote: 'Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.',
    basePrices: {
      standard: { 
        single: 9310, 
        double: 10600, 
        triple: 12100
      },
      lift: { 
        single: 12260, 
        double: 13540, 
        triple: 15040
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 360,
          'flush-30': 410,
          'recessed-15': 450,
          'recessed-30': 530,
          'recessed-15-45': 560
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 430,
          'recessed-lift-30': 500,
          'recessed-lift-5': 950
        }
      },
      fusion: {
        none: 0,
        fusion: 500,
        'fusion-modules': 200
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    specs: {
      power: '13 kW',
      efficiency: '77,3%',
      energyClass: 'A',
      glassSize: '665 x 471 mm (obie strony)',
      insertSize: '655 x 1118-1254 x 520 mm',
      fireplaceSize: '445 x 500 x 254 mm',
      maxLogLength: '490 mm',
      weight: '155 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 2 DUO',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 2 DUO w konfiguracji:\n\nModel: DRAGON 2 DUO\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.\n\nPozdrawiam'
    }
  },

  'dragon-4-duo': {
    id: 'dragon-4-duo',
    name: 'DRAGON 4 DUO',
    power: '15,5 kW',
    type: 'powietrzny nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/dragon-4-duo.jpg',
    emailSubject: 'Zapytanie - DRAGON 4 DUO',
    description: 'Wkład powietrzny dwustronny vis-a-vis 16 kW',
    specialNote: 'Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.',
    basePrices: {
      standard: { 
        single: 10330, 
        double: 11830, 
        triple: 13430
      },
      lift: { 
        single: 13270, 
        double: 14770, 
        triple: 16380
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 390,
          'flush-30': 430,
          'recessed-15': 500,
          'recessed-30': 560,
          'recessed-15-45': 630
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 450,
          'recessed-lift-30': 530,
          'recessed-lift-5': 990
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      }
    },
    specs: {
      power: '15,5 kW',
      efficiency: '78,6%',
      energyClass: 'A',
      glassSize: '717 x 471 mm (obie strony)',
      insertSize: '736 x 1102-1224 x 695 mm',
      fireplaceSize: '438 x 612 x 475 mm',
      maxLogLength: '600 mm',
      weight: '160 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4 DUO',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4 DUO w konfiguracji:\n\nModel: DRAGON 4 DUO\nMoc: 16 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.\n\nPozdrawiam'
    }
  },

  'dragon-6-xxl-duo': {
    id: 'dragon-6-xxl-duo',
    name: 'DRAGON 6 XXL DUO',
    power: '12 kW',
    type: 'powietrzny nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/dragon-6-xxl-duo.jpg',
    emailSubject: 'Zapytanie - DRAGON 6 XXL DUO',
    description: 'Wkład powietrzny dwustronny vis-a-vis 19 kW',
    specialNote: 'Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.',
    basePrices: {
      standard: { 
        single: 11290, 
        double: 13430, 
        triple: 16000
      },
      lift: { 
        single: 14240, 
        double: 16380, 
        triple: 18940
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 420,
          'flush-30': 500,
          'recessed-15': 550,
          'recessed-30': 640,
          'recessed-15-45': 690
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 510,
          'recessed-lift-30': 580,
          'recessed-lift-5': 1100
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '754 x 604 mm (obie strony)',
      insertSize: '777 x 1283-1438 x 508 mm',
      fireplaceSize: '590 x 659 x 325 mm',
      maxLogLength: '650 mm',
      weight: '197 kg'
    },
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 6 XXL DUO',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 6 XXL DUO w konfiguracji:\n\nModel: DRAGON 6 XXL DUO\nMoc: 19 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.\n\nPozdrawiam'
    }
  },

  'dragon-8-duo': {
    id: 'dragon-8-duo',
    name: 'DRAGON 8 DUO',
    power: '11,5 kW',
    type: 'powietrzny nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/dragon-8-duo.jpg',
    emailSubject: 'Zapytanie - DRAGON 8 DUO',
    description: 'Wkład powietrzny dwustronny vis-a-vis 11 kW',
    specialNote: 'Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.',
    basePrices: {
      standard: { 
        single: 8190, 
        double: 9370, 
        triple: 10760
      },
      lift: { 
        single: 11130, 
        double: 12310, 
        triple: 13700
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 300,
          'flush-30': 350,
          'recessed-15': 390,
          'recessed-30': 440,
          'recessed-15-45': 490
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 360,
          'recessed-lift-30': 410,
          'recessed-lift-5': 780
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      thermalModules: { 
        'none': 0, 
        'thermal': 235
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 370/370/80 mm (21 kg)'
      }
    },
    specs: {
      power: '11,5 kW',
      efficiency: '75,0%',
      energyClass: 'A',
      glassSize: '423 x 513 mm (obie strony)',
      insertSize: '447 x 1105-1187 x 534 mm',
      fireplaceSize: '475 x 328 x 352 mm',
      maxLogLength: '300 mm',
      weight: '105 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 8 DUO',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 8 DUO w konfiguracji:\n\nModel: DRAGON 8 DUO\nMoc: 11 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.\n\nPozdrawiam'
    }
  },

  'dragon-8-xxl-duo': {
    id: 'dragon-8-xxl-duo',
    name: 'DRAGON 8 XXL DUO',
    power: '13,7 kW',
    type: 'powietrzny nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/dragon-8-xxl-duo.jpg',
    emailSubject: 'Zapytanie - DRAGON 8 XXL DUO',
    description: 'Wkład powietrzny dwustronny vis-a-vis 13 kW',
    specialNote: 'Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.',
    basePrices: {
      standard: { 
        single: 9580, 
        double: 11190, 
        triple: 13010
      },
      lift: { 
        single: 12520, 
        double: 14130, 
        triple: 15950
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 360,
          'flush-30': 410,
          'recessed-15': 470,
          'recessed-30': 540,
          'recessed-15-45': 580
        },
        lift: { 
          none: 0, 
          'recessed-lift-30': 420,
          'recessed-lift-5': 950
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
      thermalModules: { 
        'none': 0, 
        'thermal': 235
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 370/370/80 mm (21 kg)'
      }
    },
    specs: {
      power: '13,7 kW',
      efficiency: '79,9%',
      energyClass: 'A',
      glassSize: '454 x 684 mm (obie strony)',
      insertSize: '488 x 1468-1550 x 527 mm',
      fireplaceSize: '670 x 370 x 340 mm',
      maxLogLength: '360 mm',
      weight: '115 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 8 XXL DUO',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 8 XXL DUO w konfiguracji:\n\nModel: DRAGON 8 XXL DUO\nMoc: 13 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.\n\nPozdrawiam'
    }
  },

  'dragon-9-duo': {
    id: 'dragon-9-duo',
    name: 'DRAGON 9 DUO',
    power: '13 kW',
    type: 'powietrzny nofusion',
    glassType: 'vis-a-vis' as const,
    image: 'images/dragon-9-duo.jpg',
    emailSubject: 'Zapytanie - DRAGON 9 DUO',
    description: 'Wkład powietrzny dwustronny vis-a-vis 15 kW',
    specialNote: 'Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.',
    basePrices: {
      standard: { 
        single: 12040, 
        double: 13970, 
        triple: 16320
      },
      lift: { 
        single: 14980, 
        double: 16910, 
        triple: 19260
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 420,
          'flush-30': 500,
          'recessed-15': 550,
          'recessed-30': 640,
          'recessed-15-45': 690
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 510,
          'recessed-lift-30': 580,
          'recessed-lift-5': 1100
        }
      },
      fusion: {
        basic: 1470,
        modules: 680
      },
      akuPlus: {
        'aku-plus': 0
      },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      }
    },
    
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Pojedyncza x1', 
        'double': 'Podwójna x2',
        'triple': 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      }
    },
    specs: {
      power: '13 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '904 x 454 mm (obie strony)',
      insertSize: '957 x 1095-1250 x 508 mm',
      fireplaceSize: '415 x 807 x 310 mm',
      maxLogLength: '805 mm',
      weight: '180 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 9 DUO',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 9 DUO w konfiguracji:\n\nModel: DRAGON 9 DUO\nMoc: 15 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena systemu LIFT dotyczy jednej strony. W przypadku systemu LIFT z dwóch stron - wycena indywidualna.\n\nPozdrawiam'
    }
  }
}



